import React from "react";
import Chart from "react-apexcharts";

const BarChart = ({ data }) => {
  const counts = data.map((item) => item.count ?? item.percentage);

  const formatNumber = (val) => {
  return parseFloat(Number(val).toFixed(2));
};
  const series = data.map((item) => ({
    name: item.label,
    data: [item.percentage],
  }));

  const options = {
    chart: {
      type: "bar",
      stacked: true,
      stackType: "100%", // Ensures it perfectly fills the horizontal space
      toolbar: { show: false },
      sparkline: { enabled: true }, // Removes all padding/axes for max compactness
      animations: {
        enabled: true,
        easing: 'easeinout',
        speed: 800,
      }
    },
    plotOptions: {
      bar: {
        horizontal: true,
        barHeight: "50%", // Thinner bar looks more modern/professional
        borderRadius: 6, // Softer, premium look
        colors: {
          backgroundBarColors: ['#f1f5f9'], // Adds a subtle track behind the bar
          backgroundBarOpacity: 1,
        }
      },
    },
    // Modern "Slate & Emerald" palette for a professional vibe
colors: ["#064e3b", "#059669", "#34d399", "#a7f3d0", "#ecfdf5"],    
    dataLabels: {
  enabled: true,
  textAnchor: "middle",
  formatter: (val, opts) => {
    const formattedVal = parseFloat(Number(val).toFixed(2));
    return val > 8
      ? `${opts.w.config.series[opts.seriesIndex].name} ${formattedVal}%`
      : "";
  },
},
    tooltip: {
      enabled: true,
      theme: "dark",
      x: { show: false },
      y: {
        formatter: (val, { seriesIndex }) => {
      return parseFloat(Number(counts[seriesIndex]).toFixed(2));
        },
        title: {
          formatter: (seriesName) => `${seriesName}:`,
        },
      },
      style: {
        fontSize: '12px'
      }
    },
    states: {
      hover: {
        filter: { type: 'lighten', value: 0.1 }
      },
      active: {
        allowMultipleDataPointsSelection: false,
        filter: { type: 'none' }
      }
    }
  };

  return (
    <div style={{ padding: "4px 0", width: "100%" }}>
      <Chart options={options} series={series} type="bar" height={45}  />
    </div>
  );
};

export default BarChart;